import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { currentClientUUID } from '@patsnap/uniform-setting';

export interface LsHomeAgentCard {
    goal: string;
    icon_url?: string;
    name: string;
    order: number;
    short_name: string;
    key: string;
    function_id: string;
    agent_id: number;
    type: 'playbook' | 'agent' | 'roadmap';
    feature_id: string;
    // 2025-07-22
    published_date?: string;
    charge_mode?: 'COMMERCIAL' | 'FREEMIUM' | 'TRIAL'
}

export interface LsHomeAgentGroup {
    agents: LsHomeAgentCard[];
    name: string;
    order: number;
}

export type LsHomePurchasedAgentData = Record<string, LsHomeAgentGroup>

export type LsHomeAllAgentData = Record<string, {
    groups: Record<string, LsHomeAgentGroup>
    name: string;
    order: number;
}>

export interface HomeLsApi {
    getPurchasedAgentData(): Promise<LsHomePurchasedAgentData & {show_tabs: boolean}>;
    getAllAgentData(): Promise<LsHomeAllAgentData & {common: LsHomeAgentGroup}>;
}

export const HomeLsApi = Symbol('HomeLsApi');

@injectable()
export class HomeLsApiImpl extends PsHttpService implements HomeLsApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0/homepage`,
            headers: {
                'X-Device-ID': currentClientUUID(),
                'X-API-Version': '2.0',
            },
        };
    }

    getPurchasedAgentData() {
        return this.get<PatSnapCommonResponseData<LsHomePurchasedAgentData & {show_tabs: boolean}>>({
            url: '/cards',
            params: {
                type: 'purchased',
            },
        }).then((res) => {
            return res as unknown as LsHomePurchasedAgentData & {show_tabs: boolean};
        });
    }

    getAllAgentData() {
        return this.get<PatSnapCommonResponseData<LsHomeAllAgentData & {common: LsHomeAgentGroup}>>({
            url: '/cards',
            params: {
                type: 'all',
            },
        }).then((res) => {
            return res as unknown as LsHomeAllAgentData & {common: LsHomeAgentGroup};
        });
    }
}
